import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import BookDemoPage from "./pages/BookDemoPage";
import ThankYouPage from "./pages/ThankYouPage";
import NotFoundPage from "./pages/NotFoundPage";
import {
  GovernmentPage,
  TelecommunicationsPage,
  EnergyPage,
  FinancialPage,
  HealthcarePage,
  RetailPage,
  ITPage,
  ManufacturingPage,
} from "./pages/industries";
import { ResonancePage, SOCAgentPage, IntelligencePlatformPage } from "./pages/solutions";
import SmoothScroll from "./components/SmoothScroll";
import GoogleAnalytics from "./components/GoogleAnalytics";
import "./App.css";
import "./animations.css";

function App() {
  return (
    <Router>
      <GoogleAnalytics />
      <SmoothScroll />
      <MainLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/book-demo" element={<BookDemoPage />} />
          <Route path="/demo" element={<BookDemoPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />

          {/* Industry Routes */}
          <Route path="/industries/government" element={<GovernmentPage />} />
          <Route path="/industries/telecommunications" element={<TelecommunicationsPage />} />
          <Route path="/industries/energy" element={<EnergyPage />} />
          <Route path="/industries/financial" element={<FinancialPage />} />
          <Route path="/industries/healthcare" element={<HealthcarePage />} />
          <Route path="/industries/retail" element={<RetailPage />} />
          <Route path="/industries/it" element={<ITPage />} />
          <Route path="/industries/manufacturing" element={<ManufacturingPage />} />

          {/* Solutions Routes */}
          <Route path="/solutions/resonance" element={<ResonancePage />} />
          <Route path="/solutions/autonomous-soc" element={<SOCAgentPage />} />
          <Route path="/solutions/intelligence-platform" element={<IntelligencePlatformPage />} />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App;
